import { render } from "./input-number.md?vue&type=template&id=09c2d892"
import script from "./input-number.md?vue&type=script&lang=js"
export * from "./input-number.md?vue&type=script&lang=js"
script.render = render

export default script